// extracted by mini-css-extract-plugin
export default {"icon-warning":"WarningAlert_icon-warning__8sGlc","title":"WarningAlert_title__79VLA","description":"WarningAlert_description__FGAmG"};